<script setup>

import {Search, Warning} from "@element-plus/icons-vue";
import {useRouter} from "vue-router";
const router = useRouter()
import {ref} from "vue";
const  searchText = ref(null)
defineProps({  isShow: {
    type: String,
    default: ''
  }})
const  emits = defineEmits(['clickSearch'])
const handleSearch = ()=>{
  emits('clickSearch',searchText.value)
}
</script>

<template>
  <nav class="navbar">
    <div class="logo">
      <h1>2025全网最全计算机专业毕设项目代码资料大合集</h1>
    </div>
    <div class="nav-links">
      <a  @click="router.push('/')">首页</a>
      <a href="#projects">项目</a>
      <a href="#languages">编程语言</a>
      <a href="#frameworks">框架</a>
      <a href="#tools">开发工具</a>
    </div>
  </nav>

</template>

<style scoped>
.top{
  position: fixed;
  width: 100%;
  top: 0;
}
.header{
  width: 100%;
  height: 80px;
display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: linear-gradient(to right, rgb(25,102,229), rgb(146,63,228));
  color: #fff;
}
.nav{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  font-size: 1rem;
  background-image: linear-gradient(to right, rgb(53,133,241), rgb(166,93,243));

}
.tit_header{
  width: 100%;
  text-align: center;
  font-size: 2rem;
}
.search{
  margin-left: 2px;
}


/* 导航栏样式 */
.navbar {
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 1rem 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.logo h1 {
  color: #2c3e50;
  font-size: 1.8rem;
}

.nav-links a {
  color: #34495e;
  text-decoration: none;
  margin-left: 1rem;
  font-weight: 500;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #3498db;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
  background-color: #f5f7fa;
  color: #333;
}

/* 添加新的变量 */
:root {
  --primary-color: #7C4DFF;  /* 更鲜艳的紫色 */
  --secondary-color: #00E5FF; /* 亮青色 */
  --dark-color: #2B2D42;
  --light-color: #F8F9FA;
  --accent-color: #FF4081; /* 粉色强调色 */
  --gradient-start: #7C4DFF;
  --gradient-end: #00E5FF;
  --code-font: 'Fira Code', monospace;
}
</style>
